// 確認用の負荷の表示(アドレスに ?stats を付けると出る。2026-11-01 将来構想「実機での負荷の計測」)。
// 試合の計算(src/sim/)には触らず、main.js が毎フレーム sample() に渡す数を集めて、0.5秒ごとに文字にする。
// 見るもの: fps(直近1秒)と、その回の最低 fps とそのときの敵の数・場面 / 1フレームの計算と描画の時間 / 敵・弾の数と上限 /
//   描画の細かさ(自動調整の段・倍率・実際に描く画素の数)と描く回数(draw calls)・三角形の数 / 倍率(scale)と省電力の状態。
// 数は英語の略語で出す(確認用なので i18n の表には入れない)。
export function createStats(el, { every = 0.5 } = {}) {
  let winTime = 0; // fps を測っている区間(秒)
  let winFrames = 0;
  let winSim = 0; // 区間の計算時間の合計(ms)
  let winDraw = 0; // 区間の描画時間の合計(ms)
  const winParts = { scene: 0, overlay: 0, gl: 0 }; // 区間の描画の内訳の合計(ms。view.times)
  const parts = { scene: 0, overlay: 0, gl: 0 };
  let winMaxMs = 0; // 区間でいちばん長かったフレーム(ms)
  let fps = 0;
  let simMs = 0;
  let drawMs = 0;
  let maxMs = 0;
  let sinceText = 0;
  let latest = null;
  const worst = { fps: Infinity, enemies: 0, at: 0 }; // その回の最低 fps と、そのときの敵の数・前進の秒
  let peakEnemies = 0;

  // 試合が替わったら最低 fps の記録をやり直す(main.js の startRun から)
  function reset() {
    worst.fps = Infinity;
    worst.enemies = 0;
    worst.at = 0;
    peakEnemies = 0;
  }

  // 毎フレーム呼ぶ。dt: 前のフレームからの実時間(秒)。sim/draw: このフレームの計算・描画にかかった ms。
  // world: 今映している試合(無いときは null)。view: src/view/index.js の stats()(描画の細かさ・描く回数)。power: 省電力の状態
  function sample({ dt, sim = 0, draw = 0, world = null, view = null, power = "", mode = "" }) {
    latest = { world, view, power, mode };
    if (dt > 0) {
      winTime += dt;
      winFrames++;
      winSim += sim;
      winDraw += draw;
      if (view?.times) for (const k in winParts) winParts[k] += view.times[k] || 0;
      winMaxMs = Math.max(winMaxMs, dt * 1000);
    }
    const enemies = world ? world.enemies.length : 0;
    peakEnemies = Math.max(peakEnemies, enemies);
    if (winTime >= 0.999) {
      // 1秒ごとに決める(1/60 を60回足すと丸めで 1 にわずかに届かないので、少し手前で)
      fps = winFrames / winTime;
      simMs = winSim / winFrames;
      drawMs = winDraw / winFrames;
      for (const k in winParts) {
        parts[k] = winParts[k] / winFrames;
        winParts[k] = 0;
      }
      maxMs = winMaxMs;
      if (fps < worst.fps && power !== "low") {
        worst.fps = fps;
        worst.enemies = enemies;
        worst.at = world ? world.progress || 0 : 0;
      }
      winTime = winFrames = winSim = winDraw = winMaxMs = 0;
      sinceText = every; // 新しい fps はすぐ出す
    }
    sinceText += dt;
    if (sinceText >= every) {
      sinceText = 0;
      el.textContent = text();
    }
  }

  function text() {
    const { world, view, power, mode } = latest || {};
    const lines = [];
    const worstText = worst.fps < Infinity ? ` min ${worst.fps.toFixed(0)} @${worst.enemies} enemies ${Math.round(worst.at)}s` : "";
    lines.push(`fps ${fps.toFixed(0)}${worstText}`);
    lines.push(`frame max ${maxMs.toFixed(0)}ms  sim ${simMs.toFixed(1)}ms  draw ${drawMs.toFixed(1)}ms`);
    if (view?.times) lines.push(`draw = scene ${parts.scene.toFixed(1)} + overlay ${parts.overlay.toFixed(1)} + gl ${parts.gl.toFixed(1)}`);
    if (world) lines.push(`enemies ${world.enemies.length}/${world.params?.maxAlive ?? "-"} (peak ${peakEnemies})  shots ${world.shots.length}  scale x${(world.scale || 1).toFixed(2)}`);
    if (view) {
      const q = view.mode === "auto" ? `auto L${view.level}${view.lite ? " lite" : ""}` : view.mode;
      lines.push(`quality ${q} x${view.scale.toFixed(2)}  dpr ${view.pixelRatio.toFixed(2)}  ${view.width}x${view.height}px`);
      lines.push(`draw calls ${view.calls}  tris ${(view.triangles / 1000).toFixed(0)}k`);
    }
    lines.push(`mode ${mode}  power ${power}`);
    return lines.join("\n");
  }

  return { sample, reset, text, get fps() { return fps; }, get worst() { return { ...worst }; } };
}
